import './style.scss'

type Props = {
  onChange?: (value: string) => void;
  value?: string;
  onBlur?: (value: string) => void;
  onKeyDown?: (key: string, value?: string) => void;
  disabled?: boolean;
};

export const NumberInput = ({
  onChange,
  value,
  onBlur,
  onKeyDown,
  disabled,
}: Props) => {
  const invalidChars = [
    "-",
    "+",
    "e",
  ];

  return (
    <input
      className="tru-number-input"
      type="number"
      value={value}
      onChange={(event) => onChange?.(event.currentTarget.value)}
      onBlur={(event) => onBlur?.(event.currentTarget.value)}
      onKeyDown={(event) => {
        if (invalidChars.includes(event.key)) {
          event.preventDefault();
        }
        onKeyDown?.(event.key, event.currentTarget.value)
      }}
      disabled={disabled}
    />
  );
};
